import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { learningCenterValueAdditions } from "@/data/learningCenterValueAdditions";
import { getPublicComponentCopy, isRtlPublicLang } from "@/lib/publicComponentCopy";

export default function LearningCenterValueAdditions({ prefix = "/en", lang = "en" }) {
  const withPrefix = (href) => href.startsWith("/") ? `${prefix}${href}` : href;
  const copy = getPublicComponentCopy(lang).value;
  const isRtl = isRtlPublicLang(lang);

  return (
    <section className="mt-10 rounded-[2rem] border border-[#BFDADC] bg-white/88 p-5 shadow-[0_18px_45px_rgba(8,22,51,0.08)] backdrop-blur md:p-8" dir={isRtl ? "rtl" : "ltr"}>
      <div className="mb-6 max-w-4xl">
        <p className="inline-flex items-center gap-2 rounded-full bg-[#17A6A4]/10 px-3 py-1 text-xs font-black uppercase tracking-[0.22em] text-[#168F92]">
          <Sparkles className="h-3.5 w-3.5" /> {copy.eyebrow}
        </p>
        <h2 className="mt-3 font-heading text-[2rem] font-black leading-[1.05] tracking-[-0.04em] text-[#081633] md:text-[2.8rem]">
          {copy.title}
        </h2>
        <p className="mt-3 max-w-3xl text-base font-medium leading-7 text-[#10233E] md:text-lg">
          {copy.intro}
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-5">
        {learningCenterValueAdditions.map(({ icon: Icon, href, dark }, index) => {
          const [title, text, cta] = copy.items[index] || copy.items[0];
          return (
          <Link
            key={title}
            to={withPrefix(href)}
            className={dark
              ? "group rounded-[1.35rem] border border-[#0B2545]/30 bg-[#081633] p-5 text-white shadow-[0_16px_38px_rgba(8,22,51,0.18)] transition hover:-translate-y-1 hover:border-[#17A6A4]"
              : "group rounded-[1.35rem] border border-[#BFDADC] bg-white p-5 text-[#081633] shadow-[0_14px_35px_rgba(8,22,51,0.06)] transition hover:-translate-y-1 hover:border-[#17A6A4]"
            }
          >
            <Icon className={dark ? "h-6 w-6 text-white" : "h-6 w-6 text-[#168F92]"} />
            <h3 className={dark ? "mt-4 text-lg font-black leading-tight !text-white" : "mt-4 text-lg font-black leading-tight text-[#081633]"}>{title}</h3>
            <p className={dark ? "mt-2 text-sm font-medium leading-6 text-white/82" : "mt-2 text-sm font-medium leading-6 text-[#10233E]"}>{text}</p>
            <span className={dark ? "mt-4 inline-flex items-center gap-2 text-xs font-black text-white" : "mt-4 inline-flex items-center gap-2 text-xs font-black text-[#168F92]"}>
              {cta} <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
            </span>
          </Link>
          );
        })}
      </div>
    </section>
  );
}